angular.module('Itao.IndicatorMap').directive('yearDoubleSlider', function (mapConfig, $interval) {
  'use strict';

  return {
    templateUrl: mapConfig.templateBasePath + 'dataLayerDoubleSlider.html',
    restrict: 'E',
    scope: {
      disabledDataLayers: '=',
      layers: '=',
      selectedIndicator: '='
    },
    link: function (scope, element) {
      scope.layers = [];
      scope.years = Object.keys(scope.layers);
      //scope.yearsToHide = mapConfig.yearsToHide;

      function saveYearsInsideArray() {
        scope.years = Object.keys(scope.layers);
        if (scope.selectedIndicator) {
          filterYearsByIndicator();
        }
      }

      scope.$watch('selectedIndicator', function (selectedIndicator) {
        if (scope.layers) {
          saveYearsInsideArray();
        }
      });

      function filterYearsByIndicator() {
        angular.forEach(scope.layers, function (layer, year) {
          if (layer.indicators.indexOf(scope.selectedIndicator.uid) === -1) {
            scope.years.splice(scope.years.indexOf(year), 1);
          }
        });
        rebuildSlider();
      }

      scope.$watchCollection('layers', function () {
        saveYearsInsideArray();
        rebuildSlider();
      });

      function rebuildSlider() {
        var stepsArray = [];
        var availableYears = scope.years;
        //update: handles hidden years in mapInterface
        //availableYears = mapConfig.yearsToHide ? scope.years.filter(function (year) {
        //  return mapConfig.yearsToHide.indexOf(year) === -1;
        //}) : availableYears;

        angular.forEach(availableYears, function (year, index) {
          var legendString = '';

          if (availableYears.length > 5 && index > 0 && index < availableYears.length - 1) {
            legendString = "'" + year.substring(2);
          } else {
            legendString = year;
          }
          stepsArray.push({value: year, legend: legendString});
        });

        var yearSelection = scope.disabledDataLayers.length ? availableYears.filter(function(year){ return scope.disabledDataLayers.indexOf(year) === -1; }) : availableYears;

        scope.layersSlider.options.stepsArray = stepsArray;
        scope.layersSlider.options.floor = availableYears[0];
        scope.layersSlider.options.ceil = availableYears[availableYears.length-1];
        scope.layersSlider.minValue = yearSelection[0];
        scope.layersSlider.maxValue = yearSelection[yearSelection.length-1];

      }

      var toggleSelection = function toggleSelection(min, max) {
        scope.disabledDataLayers = scope.years.filter(function(year) {
          if(year < min || year > max) {
            return year;
          }
        });
      };

      scope.layersSlider = {
        options: {
          onChange: function () {
            toggleSelection(scope.layersSlider.minValue, scope.layersSlider.maxValue);
          },
          showSelectionBar: true,
          hidePointerLabels: true,
          showTicksValues: true
        }
      };
    }
  };
});
